import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from 'app/auth/service';
import { detectCrmParams } from 'app/global/integrations/integration.helper';
import { RouterService } from 'app/global/router.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  /**
   *
   * @param {AuthenticationService} _authenticationService
   * @param {RouterService} _routerService
   * @param {Router} _router
   */
  constructor(
    private _authenticationService: AuthenticationService,
    private _routerService: RouterService,
    private _router: Router
  ) { }


  async canActivate( ) {
    const routerUrl = detectCrmParams(this._routerService.getQueryParamsFromUrl(window.location.href))
      ? (this._routerService.setCrmParams(), 'crm-login')
      : 'login';

    if (await this._authenticationService.isLoggedIn()) return true;

    // Redirect user where he came from after login
    if(routerUrl === 'login') {
      this._router.navigate(['/login']);
      return false;
    }

    this._routerService.redirectCrmUserToRoute(routerUrl);
    return false;
  }
}
